import GWSRequestErrorInfo from '../../store/schema/GWSRequestErrorInfo';
import { DatapointStatus, PerformanceDatapoint } from 'owa-analytics';
import { ResponseStatus } from '../../helpers/GriffinConstants';
import owaLocalizedStrings from 'owa-strings/owa-txp-strings';
import { HttpStatusCode } from 'owa-http-status-codes';

export default function handleSaveEditableResponse(
    response: any,
    gwsRequestErrorInfo: GWSRequestErrorInfo,
    perfDataPoint: PerformanceDatapoint,
    onError?: (clientErrorMessage: string, status: DatapointStatus, error?: Error) => void,
    onSuccess?: () => void
) {
    if (response == null) {
        onUnknownServerError(perfDataPoint, gwsRequestErrorInfo, onError);
    } else if (response === DatapointStatus.Timeout) {
        onError(owaLocalizedStrings.ErrorMessageRequestTimedOut, DatapointStatus.Timeout);
    } else if (response.Body.ResponseClass == ResponseStatus.Success) {
        onSuccess();
    } else if (gwsRequestErrorInfo.statusCode == HttpStatusCode.ServiceUnavailable) {
        onError(
            owaLocalizedStrings.ErrorMessageServerUnavailable,
            DatapointStatus.RequestNotComplete,
            Error(gwsRequestErrorInfo.serverErrorMessage)
        );
    } else if (response.Body.ResponseClass == ResponseStatus.Error) {
        switch (gwsRequestErrorInfo.statusCode) {
            case HttpStatusCode.NotImplemented:
                onError(
                    owaLocalizedStrings.ErrorMessageFeatureNotEnabled,
                    DatapointStatus.ServerError
                );
                break;
            case HttpStatusCode.Conflict:
                onError(
                    owaLocalizedStrings.ErrorMessagePreviousEditInProgress,
                    DatapointStatus.ServerError
                );
                break;
            case HttpStatusCode.Forbidden:
                onError(
                    owaLocalizedStrings.ErrorMessageNotLatestEmail,
                    DatapointStatus.ServerError
                );
                break;
            default:
                onUnknownServerError(perfDataPoint, gwsRequestErrorInfo, onError);
        }
    }
}

function onUnknownServerError(
    perfDataPoint: PerformanceDatapoint,
    gwsRequestErrorInfo: GWSRequestErrorInfo,
    onError?: (errorMessage: string, status: DatapointStatus, error?: Error) => void
): void {
    perfDataPoint.addCustomData({ serverStatusCode: gwsRequestErrorInfo.statusCode });
    onError(
        owaLocalizedStrings.ErrorGeneralMessage,
        DatapointStatus.ServerError,
        Error(gwsRequestErrorInfo.serverErrorMessage)
    );
}
